import axios from 'axios'
import {BUSCAR_CONFIGURACAO_PONTO_EMPRESA} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarAdesaoPontoPorEmpresa(empresa) {
    const url = `${URL}/configuracao-ponto/empresa/${empresa}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_CONFIGURACAO_PONTO_EMPRESA,
            payload: response,
        }),
    );
}
